import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MOP_TYPES } from "../../contants";
import { VIEW_TYPES } from "./constants";
import Details from "./details/details";
import Overview from "./overview/overview";
import styles from "./rightPanel.module.scss";

const useStyles = makeStyles()((theme) => ({
  detailsBackground: {
    backgroundColor: theme?.palette?.background.details.main,
  },
}));

function RightPanel({
  mopType,
  computations,
  currency = { symbol: "$" },
  surfaceUnit = {label: "m²"},
}) {
  const { classes, cx } = useStyles();
  const [view, setView] = useState(VIEW_TYPES.OVERVIEW);

  const totalSavings =
    computations.mopsYearlyLabourCosts[MOP_TYPES.STRING_MOP] +
    computations.mopsYearlyChemicalCosts[MOP_TYPES.STRING_MOP] -
    (computations.mopsYearlyLabourCosts[mopType] +
      computations.mopsYearlyChemicalCosts[mopType]);
  const toggle = () => {
    if (view === VIEW_TYPES.OVERVIEW) {
      setView(VIEW_TYPES.DETAILS);
    } else {
      setView(VIEW_TYPES.OVERVIEW);
    }
  };

  return (
    <div className={cx(classes.detailsBackground, styles.rightPanelContent)}>
      <div className={styles.first} hidden={view !== VIEW_TYPES.OVERVIEW}>
        <Overview
          viewSetter={toggle}
          mopType={mopType}
          currency={currency.symbol}
          totalSavings={totalSavings}
        />
      </div>
      <div className={styles.second} hidden={view === VIEW_TYPES.OVERVIEW}>
        <Details
          viewSetter={toggle}
          mopType={mopType}
          computations={computations}
          currency={currency.symbol}
          surfaceUnit={surfaceUnit.label}
          totalSavings={totalSavings}
        />
      </div>
    </div>
  );
}

export default RightPanel;
